import {} from "axios";
import { z } from "zod";
import { CuratedPlaceOfSafetySchema } from "../../types/placeOfSafety.js";
import { parseAxiosResponse } from "../helpers.js";
export const GetPlacesOfSafetyV1ResponseSchema = z
    .object({
    placesOfSafety: z.array(CuratedPlaceOfSafetySchema),
})
    .brand();
///
const parseResponseGetPlaceOfSafetyV1 = parseAxiosResponse(GetPlacesOfSafetyV1ResponseSchema);
const configV1 = {
    placeOfSafety: {
        getAll: () => ({
            url: `/api/place-of-safety/v1`,
            method: "get",
            transformResponse: parseResponseGetPlaceOfSafetyV1,
        }),
    },
};
export const placeOfSafetyV1Requests = (apiAxios) => {
    return {
        placeOfSafety: {
            getAll: () => apiAxios.request(configV1.placeOfSafety.getAll()),
        },
    };
};
//# sourceMappingURL=placeOfSafetyRequests.js.map